var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"start"},[_c('Header'),(_vm.content)?[_c('Hero',{attrs:{"heading":_vm.content.heading,"subheading":_vm.content.subHeading}}),_c('InctContent',{attrs:{"content":_vm.content}})]:_vm._e(),_c('Footer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }